import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import './Navigation.css';

const Navigation = ({ siteName, siteLogo }) => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const location = useLocation();
  const name = siteName || 'MUTU NDE ESPOIR ASBL';
  const logo = siteLogo || '/logo.png';

  const isActive = (path) => {
    return location.pathname === path;
  };

  // Fermer le menu quand on change de route
  useEffect(() => {
    setIsMenuOpen(false);
  }, [location.pathname]);

  // Fermer le menu avec Escape
  useEffect(() => {
    const handleEscape = (e) => {
      if (e.key === 'Escape' && isMenuOpen) {
        setIsMenuOpen(false);
      }
    };

    document.addEventListener('keydown', handleEscape);
    return () => document.removeEventListener('keydown', handleEscape);
  }, [isMenuOpen]);

  // Empêcher le scroll du body quand le menu est ouvert
  useEffect(() => {
    if (isMenuOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'unset';
    }
    return () => {
      document.body.style.overflow = 'unset';
    };
  }, [isMenuOpen]);

  return (
    <>
      <nav className="main-navigation">
        <div className="nav-container">
          <Link to="/" className="nav-logo" onClick={() => setIsMenuOpen(false)}>
            <img src={logo} alt={name} className="nav-logo-img" onError={(e) => { e.target.src = '/logo.png'; }} />
            <span className="nav-logo-text">{name.replace(/\s+ASBL$/, '').trim() || name}</span>
          </Link>

          <button 
            className={`nav-toggle ${isMenuOpen ? 'active' : ''}`}
            onClick={() => setIsMenuOpen(!isMenuOpen)}
            aria-label="Toggle menu"
            aria-expanded={isMenuOpen}
          >
            <span></span>
            <span></span>
            <span></span>
          </button>

          <ul className={`nav-menu ${isMenuOpen ? 'nav-menu-open' : ''}`}>
          <li>
            <Link 
              to="/" 
              className={`nav-link ${isActive('/') ? 'active' : ''}`}
              onClick={() => setIsMenuOpen(false)}
            >
              Accueil
            </Link>
          </li>
          <li>
            <Link 
              to="/historique" 
              className={`nav-link ${isActive('/historique') ? 'active' : ''}`}
              onClick={() => setIsMenuOpen(false)}
            >
              Historique
            </Link>
          </li>
          <li>
            <Link 
              to="/apropos" 
              className={`nav-link ${isActive('/apropos') ? 'active' : ''}`}
              onClick={() => setIsMenuOpen(false)}
            >
              À Propos
            </Link>
          </li>
          <li>
            <Link 
              to="/activites" 
              className={`nav-link ${isActive('/activites') ? 'active' : ''}`}
              onClick={() => setIsMenuOpen(false)}
            >
              Activités
            </Link>
          </li>
          <li>
            <Link 
              to="/contact" 
              className={`nav-link ${isActive('/contact') ? 'active' : ''}`}
              onClick={() => setIsMenuOpen(false)}
            >
              Contact
            </Link>
          </li>
        </ul>
      </div>
    </nav>
    {/* Overlay pour fermer le menu */}
    <div 
      className={`nav-overlay ${isMenuOpen ? 'active' : ''}`}
      onClick={() => setIsMenuOpen(false)}
      aria-hidden="true"
    />
    </>
  );
};

export default Navigation;

